import httpApi from '@vue3/utils/http-api'
import { api } from '@vue3/configs'

export default {
  getAllProvince: (query) => {
    return httpApi.getDataViaApi({
      url: api.registration.getAllProvince,
      queryParams: query
    })
  },
  getCitiesByProvince: (query) => {
    return httpApi.getDataViaApi({
      url: api.registration.getCitiesByProvince,
      queryParams: query
    })
  },
  getDistrictByCityCode: (query) => {
    return httpApi.getDataViaApi({
      url: api.registration.getDistrictByCityCode,
      queryParams: query
    })
  },
  getSubDistrictByDistrictCode: (query) => {
    return httpApi.getDataViaApi({
      url: api.registration.getSubDistrictByDistrictCode,
      queryParams: query
    })
  },
  getPostalCodeBySubDistrictCode: (query) => {
    return httpApi.getDataViaApi({
      url: api.registration.getPostalCodeBySubDistrictCode,
      queryParams: query
    })
  },
  getCategoryAndDepo: () => {
    return httpApi.getDataViaApi({
      url: api.registration.getCategoryAndDepo
    })
  },
  getAvailableTermsOfPayment: () => {
    return httpApi.getDataViaApi({
      url: api.cart.getAvailableTermsOfPayment
    })
  },
  getUserRegistrationDetails: () => {
    return httpApi.getDataViaApi({
      url: api.registration.getUserRegistrationDetails
    })
  },
  updateRegistrationType: (body) => {
    return httpApi.postDataViaApi({
      url: api.registration.registrationType,
      body
    })
  },
  postRegisterData: (body) => {
    return httpApi.postDataViaApi({
      url: api.registration.postRegisterData,
      body
    })
  },
  uploadFile: (body) => {
    return httpApi.uploadFileViaApi({
      url: api.registration.fileUpload,
      body
    })
  },
  markUserLogout: () => {
    return httpApi.getDataViaApi({
      url: api.registration.markUserLogout
    })
  },
  firstLoginPostApproval: () => {
    return httpApi.getDataViaApi({
      url: api.registration.firstLoginPostApproval
    })
  },
  completeRegistrationProcess: (body) => {
    return httpApi.postDataViaApi({
      url: api.registration.completeRegistrationProcess,
      body
    })
  },
  getAvailableTenants: () => {
    return httpApi.getDataViaApi({
      url: api.registration.getAvailableTenants
    })
  },
  getTenantDistributorInfo: () => {
    return httpApi.getDataViaApi({
      url: api.registration.getTenantDistributorInfo
    })
  },
  getAccountRegistrationSummary: () => {
    return httpApi.getDataViaApi({
      url: api.registration.getAccountRegistrationSummary
    })
  }
}
